import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { boardStatusesService } from '../api/board-statuses.service';
import { BOARD_KEYS } from './queryKeys';

export function useBoardStatuses(boardId: string) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  const { data, isLoading, isError } = useQuery({
    queryKey: BOARD_KEYS.statuses(orgId ?? '', boardId),
    queryFn: ({ signal }) => boardStatusesService.getByBoard(boardId, signal),
    staleTime: 300_000,
    enabled: !!orgId && !!boardId,
  });

  return {
    statuses: data?.data ?? [],
    isLoading,
    isError,
  };
}
